import React from "react";

import CategoryPage from "../routes/category";

const CategoryTemplate = (props) => <CategoryPage {...props} />;

export default CategoryTemplate;
